// axios.js
import axios from 'axios'

// const domain = "https://localhost:7298/"
//const domain = "http://94.130.142.101:8085/"
const domain = "https://api.raqmanatk.com/"

const raqmanaApi = axios.create({
  baseURL: domain
  // You can add your headers here
})


// const erpDomain = "http://localhost:58524/"
const erpDomain = "http://94.130.142.101:8086/" 

export const erpApi = axios.create({
  baseURL: erpDomain
})


export default raqmanaApi